import React from 'react'
import { SortButtons } from '../SortButtons';


const TableHeaderItem = ({ title, sortBy, sortDirection, activeSortBy, callBack }) => {
  const isActive = activeSortBy ? activeSortBy === sortBy : true;

  const handleSort = React.useCallback((sortBy) => {
    if (!isActive) {
      // Clicking a different column — always start asc
      callBack("asc", sortBy);
    } else if (sortDirection === 'desc') {
      callBack("asc", sortBy);
    } else {
      callBack("desc", sortBy);
    }
  }, [sortDirection, isActive])

  return (
    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <p>{title}</p>
      <span className='ml-2'>
        {(sortDirection && sortBy) &&
        <SortButtons
          upActive={isActive && sortDirection == "asc"}
          downActive={isActive && sortDirection == "desc"}
          handleSort={() => handleSort(sortBy)}
        />
        }
      </span>
    </div>
  );
}

export default TableHeaderItem